<template>
  <router-view />
</template>
<script>
export default {
  name: 'Legend',
};
</script>
